import React, { Component } from 'react';
import { graphql, navigate } from 'gatsby';
import styled from 'react-emotion';
import { toast } from 'react-toastify';
import ReactPixel from 'react-facebook-pixel';
import dotenv from 'dotenv'
import { connect } from 'react-redux';

import Layout from '../../components/layout';
import ProductCard from '../../components/product-card';
import Container from '../../components/container';
import searchBackground from '../../../static/images/search-background.jpg';

dotenv.config();

// Query result goes to this.props.data
export const query = graphql`
  query {
    allWifi {
      edges {
        node {
          productId
          title
          price
          duration
          discount_price
          description
          images{url,alt}
          thumbs{url,alt}
        }
      }
    }
    allReseller {
      edges {
        node {
          productId
          title
          price
          duration
          discount_price
          description
          images{url,alt}
          thumbs{url,alt}
        }
      }
    }
  }
`

class ShopPage extends Component {
  constructor(props) {
    super(props);

    this.handleSearch = this.handleSearch.bind(this);
    this.SearchBar = styled.input`
      border: 1px solid black;
      width: 100%;
      margin: 0;
      padding: 7px 11px; 
      font-size: 1em; 
      line-height: 30px;
      max-width: 600px;
      display: block;
      margin: auto;
    `
    this.Filler = styled.div`
      ${tw`pb-6 md:px-3 w-full md:w-1/2 lg:w-1/3 m-0 flex-grow`};
    `
    this.ProductsContainer = styled.div`
      ${tw`flex flex-wrap items-stretch justify-around mx-auto`}
    `
    this.BlockContainer = styled.div`
      ${tw`mx-auto block`};
    `
    this.LeftColumn = styled.div`
      ${tw`block md:inline-block w-full align-top m-auto`}
    `
    this.SearchContainer = styled.div`
      ${tw`mb-3 flex flex-col`};
      height: 200px;
      
      justify-content: space-evenly;
      background-image: url(${searchBackground});
      background-size: cover;
    `
    this.Title = styled.h2`
      font-family: Dosis;
      font-size: 28px;
      font-weight: 600;
      line-height: 41px;
      text-align: center;
      color: #686767;
    `
  }
  
  state = {
    products: [],
    productsLoaded: true,
    search: '',
    category: ''
  };

  componentDidMount() {
    const referralCode = this.props.location ? queryString.parse(this.props.location.search).ref_id : '';
    if (referralCode) {
      this.props.changeReferralCode(referralCode);
    }
    // ReactPixel.init('1231110577036563')
    // ReactPixel.pageView()
    console.log(this.props.toastMessage, this.props.toastMethod);
    if (this.props.showProductToast) {
      switch (this.props.toastMethod) {
        case 'info':
          toast.info(this.props.toastMessage, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true
          });
          break;
        
        case 'warning':
          toast.warning(this.props.toastMessage, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true
          });
          break;
        
        default:
          break;
      }

      this.props.delToast();
    }

    if (!this.props.category) {
      navigate('/');
    } else {
      this.setState({ products: this.props.products });
    }

    
    console.log('mount')
  }

  handleSearch(event) {
    let products = this.props.products
    products = products.filter((product) => {
      return product.title.toLowerCase().indexOf(
        event.target.value.toLowerCase()) !== -1;
    });
    this.setState({
      search: event.target.value,
      products
    });
  }

  render() {
    console.log('render')

    const Filler = this.Filler
    const FillerContainer = this.state.productsLoaded ? <Filler /> : <span></span>;
    const ProductsContainer = this.ProductsContainer
    const BlockContainer = this.BlockContainer
    const LeftColumn = this.LeftColumn
    const SearchContainer = this.SearchContainer
    const SearchBar = this.SearchBar;
    const Title = this.Title;

    const productCards = this.state.products.map((product) => (
      <ProductCard
        key={product.productId}
        id={product.productId}
        image={product.thumbs[0]}
        productName={product.title}
        discountPrice={product.discount_price}
        currentPrice={product.price}
        productDetail={product}
        type={this.props.category}
        slug={product.slug}
      />
    ));
    
    return (
      <Layout>
        <SearchContainer>
          <div
            style={{
              textAlign: 'center',
              fontFamily: 'Dosis',
              fontWeight: '600'
            }}
          >
            <h1 style={{ color: '#686767', fontSize: '1.25rem',marginBottom:'.2rem' }} >{(this.props.category === 'wifi') ? 'Wifi Rent' : (this.props.category=='reseller'?'Reseller':'International SIM Card')}<br/>
            <span style={{ color: '#e92028', fontSize: '1rem' }} > by Wifi Republic</span></h1>
          </div>
          <Container>
            <SearchBar
              key="searchBar"
              type="text"
              placeholder={(this.props.category === 'wifi') ? 'Cari Paket Internet...' : (this.props.category=='reseller'?'Cari Produk...':'Cari SIM Card...')}
              onChange={this.handleSearch}
              value={this.state.search}
            />
          </Container>
        </SearchContainer>
        <Container>
          <Title>{(this.props.category === 'wifi') ? 'Jelajahi Semua Paket Internet Kami' : (this.props.category=='reseller'?'Jelajahi Semua Produk Reseller':'Jelajahi Semua SIM Card Internasional kami')}</Title>
          <LeftColumn>
            <BlockContainer>
              <ProductsContainer>
                {productCards}
                {FillerContainer}
                {FillerContainer}
              </ProductsContainer>
            </BlockContainer>
          </LeftColumn>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = state => {
  return {
    showProductToast: state.showProductToast,
    toastMessage: state.toastMessage,
    toastMethod: state.toastMethod
  }
}

const mapDispatchToProps = dispatch => {
  return {
    delToast: () => dispatch({ type: `DEL_TOAST` }),
    changeReferralCode: (code) => dispatch({ type: 'CHANGE_REFERRAL_CODE', code })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShopPage);